export default function prenatalFaq(element) {
    const items = Array.from(element.querySelectorAll("[data-prenatal-faq-item]"));

    if (!items.length) {
        return;
    }

    const setItemState = (item, isOpen) => {
        const button = item.querySelector("[data-prenatal-faq-button]");
        const panel = item.querySelector("[data-prenatal-faq-panel]");
        const content = item.querySelector("[data-prenatal-faq-content]");

        item.classList.toggle("is-open", isOpen);
        button.setAttribute("aria-expanded", isOpen ? "true" : "false");

        if (isOpen) {
            panel.hidden = false;
            panel.style.height = content.offsetHeight + "px";
        } else {
            panel.style.height = panel.offsetHeight + "px";
            requestAnimationFrame(() => {
                panel.style.height = "0px";
            });
        }
    };

    items.forEach((item, index) => {
        const button = item.querySelector("[data-prenatal-faq-button]");
        const panel = item.querySelector("[data-prenatal-faq-panel]");
        const content = item.querySelector("[data-prenatal-faq-content]");
        const isOpen = item.classList.contains("is-open");

        button.setAttribute("aria-expanded", isOpen ? "true" : "false");
        panel.hidden = !isOpen;
        panel.style.height = isOpen ? content.offsetHeight + "px" : "0px";

        button.addEventListener("click", () => {
            if (item.classList.contains("is-open")) {
                return;
            }

            items.forEach((currentItem) => setItemState(currentItem, currentItem === item));
        });

        button.addEventListener("keydown", (event) => {
            const direction = event.key === "ArrowDown" ? 1 : event.key === "ArrowUp" ? -1 : 0;

            if (!direction) {
                return;
            }

            event.preventDefault();
            const nextIndex = (index + direction + items.length) % items.length;
            items[nextIndex].querySelector("[data-prenatal-faq-button]").focus();
        });
    });

    element.querySelectorAll("[data-prenatal-faq-panel]").forEach((panel) => {
        panel.addEventListener("transitionend", () => {
            const item = panel.closest("[data-prenatal-faq-item]");

            if (item.classList.contains("is-open")) {
                panel.style.height = "auto";
            } else {
                panel.hidden = true;
            }
        });
    });

    window.addEventListener("resize", () => {
        const openPanel = element.querySelector("[data-prenatal-faq-item].is-open [data-prenatal-faq-panel]");
        const openContent = element.querySelector("[data-prenatal-faq-item].is-open [data-prenatal-faq-content]");

        if (openPanel && openContent) {
            openPanel.style.height = openContent.offsetHeight + "px";
            requestAnimationFrame(() => {
                openPanel.style.height = "auto";
            });
        }
    });
}
